import React, { useEffect, useRef, useState } from 'react';
import Header from '../components/Header';
import { ASSETS } from '../constants/assets';
import { ApiError, verifyEmail } from '../services/auth';
import { useTranslations } from '../translations';
import './Register.css';

interface VerifyEmailProps {
  token: string;
  onNavigateToLogin: () => void;
  onNavigateToHome: () => void;
}

type VerificationStatus = 'verifying' | 'success' | 'expired' | 'invalid' | 'error';

const VerifyEmail: React.FC<VerifyEmailProps> = ({ token, onNavigateToLogin, onNavigateToHome }) => {
  const t = useTranslations();
  const [status, setStatus] = useState<VerificationStatus>('verifying');
  const verifiedToken = useRef<string | null>(null);

  useEffect(() => {
    if (verifiedToken.current === token) {
      return;
    }
    verifiedToken.current = token;
    setStatus('verifying');

    verifyEmail(token)
      .then(() => setStatus('success'))
      .catch((error) => {
        if (error instanceof ApiError && error.hasErrorCode('user_email_verification_token_expired')) {
          setStatus('expired');
        } else if (error instanceof ApiError && error.hasErrorCode('user_email_verification_token_invalid')) {
          setStatus('invalid');
        } else {
          setStatus('error');
        }
      });
  }, [token]);

  const title = status === 'verifying'
    ? t.emailVerification.verifyingTitle
    : status === 'success'
      ? t.emailVerification.successTitle
      : t.emailVerification.errorTitle;

  const description = status === 'verifying'
    ? t.emailVerification.verifyingDescription
    : status === 'success'
      ? t.emailVerification.successDescription
      : status === 'expired'
        ? t.emailVerification.expiredDescription
        : status === 'invalid'
          ? t.emailVerification.invalidDescription
          : t.emailVerification.errorDescription;

  return (
    <div className="register-page">
      <Header
        isLoggedIn={false}
        onNavigateToLogin={onNavigateToLogin}
        onNavigateToRegister={() => {}}
        onNavigateToHome={onNavigateToHome}
      />
      <div className="register-content">
        <div className="register-form-container">
          <div className="register-form-wrapper register-verification-state">
            <h1 className="register-title">{title}</h1>
            <p className="register-verification-description">{description}</p>
            {status !== 'verifying' && (
              <button type="button" className="btn-submit" onClick={onNavigateToLogin}>
                {t.emailVerification.loginButton}
              </button>
            )}
          </div>
        </div>
        <div className="register-image-container">
          <img src={ASSETS.REGISTER_IMAGE} alt="" className="register-image" />
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
